import { useQuery } from "@tanstack/react-query";

import { exportCropMixComposerCommercialMixes } from "services";

import { EXPORT_CROP_MIX_COMPOSER_COMMERCIAL_MIXES } from "consts";

export const useExportCropMixComposerCommercialMixes = () =>
  useQuery({
    queryKey: [EXPORT_CROP_MIX_COMPOSER_COMMERCIAL_MIXES],
    queryFn: async ({ signal }) => {
      const response = await exportCropMixComposerCommercialMixes({ signal });
      return response || [];
    },
    staleTime: 0,
    refetchOnWindowFocus: true, // making true as it was commented out for and defualt is being set as false (speak with alp about it)
    refetchOnMount: "always",
  });
